import _ from 'underscore';
import { statusesHash } from '@culture/utils/helpers/statuses';
import { getEntityUrl } from '@culture/utils/helpers/entities';

export const getTagsByRubrics = (rubrics) =>
	_(rubrics).reduce((memo, rubric) => {
		const tag = {
			title: rubric.title,
			url: `/${rubric.path}`
		};

		return rubric.path !== 'main' ? memo.concat(tag) : memo;
	}, []);

export const getEntityTags = (entity, options = {}) => {
	let tags = [];

	if (entity.tags && entity.tags.length) {
		tags = tags.concat(
			_(entity.tags.filter((tag) => tag.status === statusesHash.published))
				.sortBy('isImportant')
				.reverse()
				.map((tag) => ({
					title: tag.title,
					url: getEntityUrl('tags', tag)
				}))
		);
	}

	let rubrics = entity.rubric ? [entity.rubric] : entity.rubrics || [];

	if (options.rejectedRubrics) {
		rubrics = _(rubrics).reject((rubric) =>
			_(options.rejectedRubrics).contains(rubric.path)
		);
	}

	tags = tags.concat(getTagsByRubrics(rubrics));

	return tags;
};

export const getPoemTags = (poem) => {
	const filteredTags = poem.tags.filter(
		({ status }) => status === statusesHash.published
	);
	const tags = [];

	tags.push(
		...filteredTags.map((tag) => ({
			title: tag.title,
			url: `/literature/poems/tag-${tag.name}`
		}))
	);

	if (poem.author) {
		tags.push(
			...filteredTags.map((tag) => ({
				title: `Стихи ${poem.author.fullNameGenitive} \u2013 ${tag.title}`,
				url: `/literature/poems/author-${poem.author.name}/tag-${tag.name}`
			}))
		);
	}

	return tags;
};
